import { useState } from "react";

export function useError(initialState = null) {
  const [error, setError] = useState<string | null>(initialState);

  return { error, setError };
}
